import type { Quill } from "react-quill-new";

/**
 * Load HTML so quill-table-better tables render.
 * Clear without setContents, then insert via updateContents (required for tables).
 * @see https://github.com/attoae/quill-table-better#quickstart
 */
export function setQuillHtml(quill: Quill, html: string): void {
    const delta = quill.clipboard.convert({ html: html || "" });

    // Avoid setContents entirely: quill-table-better tables break when loaded that way.
    quill.deleteText(0, quill.getLength(), "silent");
    quill.updateContents(delta, "silent");

    try {
        const [range] = quill.selection.getRange();
        quill.setSelection(Math.max(0, delta.length() - (range?.length || 0)), "silent");
        quill.scrollSelectionIntoView?.();
    } catch {
        // Selection can fail when the editor is unfocused / not yet ready.
    }
}

export function htmlHasTable(html: string): boolean {
    return /<table[\s>]/i.test(html || "");
}
